<template>
  <div class="container tab-wrap">
    <div class="tab clearfix tab-mobile">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        :class="[
          'item',
          'fl',
          { itemActive: activeIndex == index },
          smallSize == true ? 'fs-14' : 'fs-30',
        ]"
        @click="change(index)"
      >
        <span>{{ item.title }}</span>
        <!-- <span>{{ item.en }}</span> -->
      </div>
      <div class="fr clearfix md-hidden flex-container right_wrap">
        <div>
          <div
            class="fl color-fff"
            style="font-size: 14px; line-height: 16px; margin-right: 10px"
          >
            {{ $t("public.currentpage") }}:
          </div>
          <div class="fr">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">{{ $t("homepage.home") }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{ breadTitle.cn }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{
                tabList[activeIndex].title
              }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <!-- <div>
          <div
            class="fl color-fff"
            style="font-size: 14px; line-height: 16px; margin-right: 10px"
          >
            Current Page:
          </div>
          <div class="fr">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
              <el-breadcrumb-item>{{ breadTitle.en }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{
                tabList[activeIndex].en
              }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
    activeIndex: {
      type: [Number, String],
      default: 0,
    },
    breadTitle: {
      type: Object,
      default: "面包屑标题",
    },
    customEvent: {
      type: Boolean,
      default: false,
    },
    smallSize: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    $route(to, from) {
      if (to.query.tab != from.query.tab) {
        this.change(to.query.tab);
      }
    },
  },
  components: {},
  mounted() {
    const params = this.$route.query.tab;
    params && this.change(this.$route.query.tab);
  },
  data() {
    return {};
  },
  methods: {
    change(index) {
      if (!this.customEvent) {
        this.$parent.activeIndex = index;
      }
      /* 特殊跳转 媒体证申请  */
      if (this.$route.path == "/mediaCenter" && index == 1) {
        // let routeData = this.$router.resolve({ name: "mediaApply" });
        // window.open(routeData.href, "_blank");
      } else {
        this.$router.push({
          path: `${this.$route.path}?tab=${index}`,
        });
      }
      this.$emit("change", index);
    },
  },
};
</script>

<style scoped lang="scss">
.tab {
  padding: 55px 0px 10px;
  .item {
    position: relative;
    margin-left: 30px;
    color: #cccccc;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:after {
      display: block;
      content: "";
      position: absolute;
      bottom: -10px;
      height: 4px;
      background-color: #42abff;
      content: "";
      width: 0;
      height: 4px;
      transition: all 0.3s;
    }
    &:first-child {
      margin-left: 0px;
    }
  }
  .itemActive {
    position: relative;
    color: #42abff;
    &:after {
      width: 100%;
    }
  }
}
@media screen and (min-width: 100px) and (max-width: 1000px) {
  .md-hidden {
    display: none;
  }
  .tab-mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    .item {
      margin: 0 20px;
    }
  }
  .container {
    border-bottom: none;
  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
  .container {
    padding: 0;
    border-bottom: 2px solid #666666;
  }
}
</style>

<style>
.el-breadcrumb__inner {
  color: rgba(255, 255, 255, 0.8) !important;
}
</style>



// WEBPACK FOOTER //
// myTab.vue?c71f025e